document.addEventListener('DOMContentLoaded', function () {
  initShinkawaHeroSliders();
  initFeatureColumnsSlider();
  initCollectionFilters();
  prepareOpeningAnimation();
  initScrollBlurReveal();
  initScrollFadeReveal();
  saveRecentlyViewedProduct();
  initRecentlyViewedProducts();
  initShinkawaProductMain();
  initShinkawaRelatedProducts();
  initShinkawaProductCarousels();
});

window.addEventListener('load', function () {
  startOpeningAnimation();
});

document.addEventListener('shopify:section:load', function () {
  initShinkawaHeroSliders();
  initFeatureColumnsSlider();
  initScrollBlurReveal();
  initScrollFadeReveal();
  initRecentlyViewedProducts();
  initShinkawaProductMain();
  initShinkawaRelatedProducts();
  initShinkawaProductCarousels();
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initShinkawaProductCarousels, 800);
});

document.addEventListener('shopify:section:load', function () {
  setTimeout(initShinkawaProductCarousels, 800);
});

function initShinkawaHeroSliders() {
  const sections = document.querySelectorAll('.shinkawa-hero');

  sections.forEach(function (section) {
    if (section.dataset.sliderInitialized === 'true') return;

    const track = section.querySelector('.shinkawa-hero__inner');
    const prevButton = section.querySelector('.shinkawa-hero__arrow--prev');
    const nextButton = section.querySelector('.shinkawa-hero__arrow--next');
    const slides = section.querySelectorAll('.shinkawa-hero__item');

    if (!track || !prevButton || !nextButton || slides.length === 0) return;

    let currentIndex = 0;

    function isMobile() {
      return window.innerWidth < 750;
    }

    function getScrollLeftForSlide(index) {
      const trackStyle = window.getComputedStyle(track);
      const paddingLeft = parseFloat(trackStyle.paddingLeft) || 0;
      return slides[index].offsetLeft - paddingLeft;
    }

    function goToSlide(index) {
      if (!isMobile()) return;

      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;

      currentIndex = index;

      track.scrollTo({
        left: getScrollLeftForSlide(currentIndex),
        behavior: 'smooth'
      });

      updateArrows();
    }

    function updateCurrentIndexFromScroll() {
      if (!isMobile()) {
        currentIndex = 0;
        return;
      }

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        const distance = Math.abs(track.scrollLeft - getScrollLeftForSlide(index));
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      currentIndex = closestIndex;
    }

    function updateArrows() {
      if (!isMobile()) {
        prevButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      updateCurrentIndexFromScroll();

      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex === slides.length - 1;
    }

    prevButton.addEventListener('click', function () {
      goToSlide(currentIndex - 1);
    });

    nextButton.addEventListener('click', function () {
      goToSlide(currentIndex + 1);
    });

    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      window.requestAnimationFrame(updateArrows);
    });

    window.addEventListener('resize', function () {
      updateArrows();
    });

    updateArrows();
    section.dataset.sliderInitialized = 'true';
  });
}

function initFeatureColumnsSlider() {
  const sections = document.querySelectorAll('.shinkawa-feature-columns');

  sections.forEach(function (section) {
    if (section.dataset.featureSliderInitialized === 'true') return;

    const trackWrap = section.querySelector('.shinkawa-feature-columns__track-wrap');
    const prevButton = section.querySelector('.shinkawa-feature-columns__arrow--prev');
    const nextButton = section.querySelector('.shinkawa-feature-columns__arrow--next');
    const cards = section.querySelectorAll('.shinkawa-feature-card');

    if (!trackWrap || !prevButton || !nextButton || cards.length === 0) return;

    function getStep() {
      if (cards.length < 2) return cards[0].offsetWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function getMaxScroll() {
      return Math.max(trackWrap.scrollWidth - trackWrap.clientWidth, 0);
    }

    function getClosestIndex() {
      const step = getStep();
      if (!step) return 0;
      return Math.round(trackWrap.scrollLeft / step);
    }

    function scrollToIndex(index) {
      const step = getStep();
      const maxScroll = getMaxScroll();

      let target = step * index;
      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;

      trackWrap.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    }

    function updateArrows() {
      const maxScroll = getMaxScroll();
      prevButton.disabled = trackWrap.scrollLeft <= 1;
      nextButton.disabled = trackWrap.scrollLeft >= maxScroll - 1 || maxScroll <= 0;
    }

    prevButton.addEventListener('click', function () {
      const currentIndex = getClosestIndex();
      scrollToIndex(currentIndex - 1);
    });

    nextButton.addEventListener('click', function () {
      const currentIndex = getClosestIndex();
      const step = getStep();
      const maxScroll = getMaxScroll();
      const nextScroll = step * (currentIndex + 1);

      trackWrap.scrollTo({
        left: Math.min(nextScroll, maxScroll),
        behavior: 'smooth'
      });
    });

    trackWrap.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(updateArrows);
    });

    let isPointerDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    trackWrap.addEventListener('pointerdown', function (event) {
      isPointerDown = true;
      startX = event.clientX;
      startScrollLeft = trackWrap.scrollLeft;
      trackWrap.classList.add('is-dragging');
    });

    trackWrap.addEventListener('pointermove', function (event) {
      if (!isPointerDown) return;
      const diff = event.clientX - startX;
      trackWrap.scrollLeft = startScrollLeft - diff;
    });

    function endDrag() {
      isPointerDown = false;
      trackWrap.classList.remove('is-dragging');
    }

    trackWrap.addEventListener('pointerup', endDrag);
    trackWrap.addEventListener('pointercancel', endDrag);
    trackWrap.addEventListener('pointerleave', endDrag);

    updateArrows();
    section.dataset.featureSliderInitialized = 'true';
  });
}

function initCollectionFilters() {
  const filters = document.getElementById('shinkawa-collection-filters');
  if (!filters) return;
  if (filters.dataset.initialized === 'true') return;

  const openBtn = document.querySelector('[data-filters-open]');
  const closeBtns = filters.querySelectorAll('[data-filters-close]');
  let scrollY = 0;

  function openFilters() {
    scrollY = window.scrollY || window.pageYOffset;

    filters.classList.add('is-open');
    document.body.classList.add('is-filter-open');
    document.body.style.top = '-' + scrollY + 'px';
  }

  function closeFilters() {
    filters.classList.remove('is-open');
    document.body.classList.remove('is-filter-open');
    document.body.style.top = '';

    window.scrollTo(0, scrollY);
  }

  if (openBtn) {
    openBtn.addEventListener('click', openFilters);
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeFilters);
  });

  filters.dataset.initialized = 'true';
}

function prepareOpeningAnimation() {
  const opening = document.getElementById('shinkawaOpening');
  if (!opening) return;

  const html = document.documentElement;
  const isThemeEditor = typeof Shopify !== 'undefined' && Shopify.designMode;
  const storageKey = isThemeEditor
  ? 'shinkawaOpeningSeenEditor'
  : 'shinkawaOpeningSeen';
  const hasSeenOpening = sessionStorage.getItem(storageKey);

  if (hasSeenOpening === 'true') {
    opening.remove();
    return;
  }

  html.classList.add('show-opening');
  opening.classList.remove('is-hidden');
  opening.classList.remove('is-logo-visible');
  document.body.classList.add('is-opening');

  sessionStorage.setItem(storageKey, 'true');

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      opening.classList.add('is-logo-visible');
    });
  });
}

function startOpeningAnimation() {
  const opening = document.getElementById('shinkawaOpening');
  if (!opening) return;

  const html = document.documentElement;
  const isThemeEditor = typeof Shopify !== 'undefined' && Shopify.designMode;

  if (!html.classList.contains('show-opening')) return;

  const holdTime = isThemeEditor ? 900 : 1600;
  const fadeTime = isThemeEditor ? 1400 : 1600;

  window.setTimeout(function () {
    opening.classList.add('is-hidden');

    window.setTimeout(function () {
      document.body.classList.remove('is-opening');
      html.classList.remove('show-opening');

      opening.remove();
    }, fadeTime);
  }, holdTime);
}

function initScrollBlurReveal() {
  const targets = document.querySelectorAll('.js-scroll-blur');
  if (!targets.length) return;

  const observer = new IntersectionObserver(function (entries, observerInstance) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      setTimeout(function () {
        entry.target.classList.add('is-visible');
      }, 100);

      observerInstance.unobserve(entry.target);
    });
  }, {
    threshold: 0.4,
    rootMargin: '0px 0px -20% 0px'
  });

  targets.forEach(function (target) {
    observer.observe(target);
  });
}

function initScrollFadeReveal() {
  const targets = document.querySelectorAll('.js-scroll-fade');
  if (!targets.length) return;

  const observer = new IntersectionObserver(function (entries, observerInstance) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      setTimeout(function () {
        requestAnimationFrame(function () {
          entry.target.classList.add('is-visible');
        });
      }, 80);

      observerInstance.unobserve(entry.target);
    });
  }, {
    threshold: 0.25,
    rootMargin: '0px 0px -10% 0px'
  });

  targets.forEach(function (target) {
    if (target.classList.contains('is-visible')) return;
    observer.observe(target);
  });
}

function saveRecentlyViewedProduct() {
  const productJson = document.getElementById('ShinkawaProductJson');
  if (!productJson) return;

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch (error) {
    return;
  }

  if (!product || !product.id) return;

  const storageKey = 'shinkawaRecentlyViewedProducts';
  let items = [];

  try {
    items = JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch (error) {
    items = [];
  }

  items = items.filter(function (item) {
    return String(item.id) !== String(product.id);
  });

  items.unshift(product);
  items = items.slice(0, 10);

  localStorage.setItem(storageKey, JSON.stringify(items));
}

function initRecentlyViewedProducts() {
  const roots = document.querySelectorAll('[data-recently-viewed-root]');
  if (!roots.length) return;

  const storageKey = 'shinkawaRecentlyViewedProducts';

  let items = [];

  try {
    items = JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch (error) {
    items = [];
  }

  roots.forEach(function (root) {
    const trackWrap = root.querySelector('[data-recently-viewed-track-wrap]');
    const track = root.querySelector('[data-recently-viewed-track]');
    const nav = root.querySelector('[data-recently-viewed-nav]');

    if (!trackWrap || !track) return;

    if (!items.length) {
      root.hidden = true;
      return;
    }

    track.innerHTML = items.map(function (product) {
      const priceNumber = Math.round((product.price || 0) / 100).toLocaleString('ja-JP');

      return `
        <a href="${product.url}" class="shinkawa-recently-viewed__card">
          <div class="shinkawa-recently-viewed__image-wrap">
            <div class="shinkawa-recently-viewed__image-media">
              <img src="${product.image}" alt="${escapeHtml(product.title)}" class="shinkawa-recently-viewed__image" loading="lazy">
            </div>
          </div>

          <div class="shinkawa-recently-viewed__meta">
            <p class="shinkawa-recently-viewed__title">${escapeHtml(product.title)}</p>

            <p class="shinkawa-recently-viewed__price">
              <span class="shinkawa-recently-viewed__price-number">${priceNumber}</span>
              <span class="shinkawa-recently-viewed__price-unit">円</span>
              <span class="shinkawa-recently-viewed__tax-paren">(</span>
              <span class="shinkawa-recently-viewed__tax-text">税込</span>
              <span class="shinkawa-recently-viewed__tax-paren">)</span>
            </p>
          </div>
        </a>
      `;
    }).join('');

    root.hidden = false;

    const prevButton = root.querySelector('.shinkawa-recently-viewed__arrow--prev');
    const nextButton = root.querySelector('.shinkawa-recently-viewed__arrow--next');

    if (!prevButton || !nextButton || !nav) return;

    function updateArrows() {
      const maxScroll = Math.max(trackWrap.scrollWidth - trackWrap.clientWidth, 0);

      prevButton.disabled = trackWrap.scrollLeft <= 1;
      nextButton.disabled = trackWrap.scrollLeft >= maxScroll - 1 || maxScroll <= 0;
    }

    function updateNav() {
      if (track.scrollWidth > trackWrap.clientWidth + 10) {
        nav.hidden = false;
        updateArrows();
      } else {
        nav.hidden = true;
        prevButton.disabled = true;
        nextButton.disabled = true;
      }
    }
    function getStep() {
      const card = track.querySelector('.shinkawa-recently-viewed__card');
      if (!card) return 0;

      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    prevButton.addEventListener('click', function () {
      trackWrap.scrollBy({
        left: -getStep(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', function () {
      trackWrap.scrollBy({
        left: getStep(),
        behavior: 'smooth'
      });
    });

    trackWrap.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(updateNav);
    });

    requestAnimationFrame(function () {
      updateNav();
      updateArrows();
    });
    
  });
}

// function initRecentlyViewedProducts() {
//   const root = document.querySelector('[data-recently-viewed-root]');
//   const trackWrap = document.querySelector('[data-recently-viewed-track-wrap]');
//   const track = document.querySelector('[data-recently-viewed-track]');
//   const nav = document.querySelector('[data-recently-viewed-nav]');

//   if (!root || !trackWrap || !track) return;

//   const storageKey = 'shinkawaRecentlyViewedProducts';
//   let items = [];

//   try {
//     items = JSON.parse(localStorage.getItem(storageKey)) || [];
//   } catch (error) {
//     items = [];
//   }

//   if (!items.length) {
//     root.hidden = true;
//     return;
//   }

//   track.innerHTML = items.map(function (product) {
//     const priceNumber = Math.round((product.price || 0) / 100).toLocaleString('ja-JP');
//     const hasLimited = Array.isArray(product.tags) && product.tags.indexOf('限定商品') !== -1;

//     return `
//       <a href="${product.url}" class="shinkawa-recently-viewed__card">
//         <div class="shinkawa-recently-viewed__image-wrap">
//           <div class="shinkawa-recently-viewed__image-media">
//             <img src="${product.image}" alt="${escapeHtml(product.title)}" class="shinkawa-recently-viewed__image" loading="lazy">
//           </div>
//         </div>

//         <div class="shinkawa-recently-viewed__meta">
//           <p class="shinkawa-recently-viewed__title">${escapeHtml(product.title)}</p>

//           <p class="shinkawa-recently-viewed__price">
//             <span class="shinkawa-recently-viewed__price-number">${priceNumber}</span>
//             <span class="shinkawa-recently-viewed__price-unit">円</span>
//             <span class="shinkawa-recently-viewed__tax-paren">(</span>
//             <span class="shinkawa-recently-viewed__tax-text">税込</span>
//             <span class="shinkawa-recently-viewed__tax-paren">)</span>
//           </p>
//         </div>
//       </a>
//     `;
//   }).join('');

//   root.hidden = false;

//   const prevButton = root.querySelector('.shinkawa-recently-viewed__arrow--prev');
//   const nextButton = root.querySelector('.shinkawa-recently-viewed__arrow--next');

//   if (!prevButton || !nextButton) return;

//   if (track.scrollWidth > trackWrap.clientWidth + 10) {
//     nav.hidden = false;
//   } else {
//     nav.hidden = true;
//     return;
//   }

//   function getStep() {
//     const card = track.querySelector('.shinkawa-recently-viewed__card');
//     if (!card) return 0;
//     const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0);
//     return card.offsetWidth + gap;
//   }

//   function updateArrows() {
//     const maxScroll = Math.max(trackWrap.scrollWidth - trackWrap.clientWidth, 0);
//     prevButton.disabled = trackWrap.scrollLeft <= 1;
//     nextButton.disabled = trackWrap.scrollLeft >= maxScroll - 1;
//   }

//   prevButton.addEventListener('click', function () {
//     trackWrap.scrollBy({ left: -getStep(), behavior: 'smooth' });
//   });

//   nextButton.addEventListener('click', function () {
//     trackWrap.scrollBy({ left: getStep(), behavior: 'smooth' });
//   });

//   trackWrap.addEventListener('scroll', function () {
//     window.requestAnimationFrame(updateArrows);
//   });

//   window.addEventListener('resize', function () {
//     window.requestAnimationFrame(updateArrows);
//   });

//   updateArrows();
// }

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function initShinkawaProductMain() {
  const sections = document.querySelectorAll('.shinkawa-product-main');

  sections.forEach(function (section) {
    if (section.dataset.productMainInitialized === 'true') return;

    const mediaItems = Array.from(section.querySelectorAll('[data-product-media-item]'));
    const thumbs = Array.from(section.querySelectorAll('[data-thumbnail-id]'));
    const prevThumbButton = section.querySelector('.shinkawa-product-main__thumb-arrow--prev');
    const nextThumbButton = section.querySelector('.shinkawa-product-main__thumb-arrow--next');

    const quantityInput = section.querySelector('[data-quantity-input]');
    const quantityMinus = section.querySelector('[data-quantity-minus]');
    const quantityPlus = section.querySelector('[data-quantity-plus]');

    const optionButtons = section.querySelectorAll('[data-option-button]');
    const optionSelects = section.querySelectorAll('.single-option-selector');

    function getActiveIndex() {
      return mediaItems.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
    }

    function updateThumbArrows() {
      if (!prevThumbButton || !nextThumbButton || !mediaItems.length) return;

      const activeIndex = getActiveIndex();
      prevThumbButton.disabled = activeIndex <= 0;
      nextThumbButton.disabled = activeIndex >= mediaItems.length - 1;
    }

    function showMediaByIndex(index) {
      if (!mediaItems.length || !thumbs.length) return;

      if (index < 0) index = 0;
      if (index > mediaItems.length - 1) index = mediaItems.length - 1;

      const targetItem = mediaItems[index];
      const targetId = String(targetItem.dataset.mediaId);

      mediaItems.forEach(function (item) {
        item.classList.toggle('is-active', String(item.dataset.mediaId) === targetId);
      });

      thumbs.forEach(function (thumb) {
        const isActive = String(thumb.dataset.thumbnailId) === targetId;
        thumb.classList.toggle('is-active', isActive);

        if (isActive) {
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });

      updateThumbArrows();
    }

    function showMediaById(mediaId) {
      const index = mediaItems.findIndex(function (item) {
        return String(item.dataset.mediaId) === String(mediaId);
      });

      if (index !== -1) {
        showMediaByIndex(index);
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMediaById(thumb.dataset.thumbnailId);
      });
    });

    if (prevThumbButton) {
      prevThumbButton.addEventListener('click', function () {
        const activeIndex = getActiveIndex();
        showMediaByIndex(activeIndex - 1);
      });
    }

    if (nextThumbButton) {
      nextThumbButton.addEventListener('click', function () {
        const activeIndex = getActiveIndex();
        showMediaByIndex(activeIndex + 1);
      });
    }

    function syncOptionButtons(selectElement) {
      const index = selectElement.dataset.index;

      optionButtons.forEach(function (button) {
        if (button.dataset.optionIndex !== index) return;

        button.classList.toggle(
          'is-active',
          button.dataset.optionValue === selectElement.value
        );
      });
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const optionIndex = button.dataset.optionIndex;
        const optionValue = button.dataset.optionValue;

        const matchingSelect = section.querySelector('.single-option-selector[data-index="' + optionIndex + '"]');
        if (!matchingSelect) return;

        matchingSelect.value = optionValue;
        matchingSelect.dispatchEvent(new Event('change', { bubbles: true }));

        optionButtons.forEach(function (targetButton) {
          if (targetButton.dataset.optionIndex === optionIndex) {
            targetButton.classList.remove('is-active');
          }
        });

        button.classList.add('is-active');
      });
    });

    optionSelects.forEach(function (selectElement) {
      selectElement.addEventListener('change', function () {
        syncOptionButtons(selectElement);
      });

      syncOptionButtons(selectElement);
    });

    function updateQuantityButtons() {
      if (!quantityInput || !quantityMinus) return;

      const currentValue = parseInt(quantityInput.value, 10) || 1;
      const minValue = parseInt(quantityInput.min, 10) || 1;
      quantityMinus.disabled = currentValue <= minValue;

      if (quantityPlus) {
        quantityPlus.disabled = false;
      }
    }

    if (quantityInput && quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        const currentValue = parseInt(quantityInput.value, 10) || 1;
        const minValue = parseInt(quantityInput.min, 10) || 1;
        quantityInput.value = Math.max(currentValue - 1, minValue);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateQuantityButtons();
      });
    }

    if (quantityInput && quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        const currentValue = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = currentValue + 1;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateQuantityButtons();
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', updateQuantityButtons);
      quantityInput.addEventListener('input', updateQuantityButtons);
    }

    updateQuantityButtons();
    updateThumbArrows();
    section.dataset.productMainInitialized = 'true';
  });
}



function initShinkawaRelatedProducts() {
  const sections = document.querySelectorAll('[data-related-products-root]');

  sections.forEach(function (section) {
    const trackWrap = section.querySelector('[data-related-products-track-wrap]');
    const prev = section.querySelector('.shinkawa-related-products__arrow--prev');
    const next = section.querySelector('.shinkawa-related-products__arrow--next');

    if (!trackWrap || !prev || !next) return;

    function getStep() {
      const item = section.querySelector('.shinkawa-related-products__item');
      if (!item) return 0;

      const gap = 20;
      return item.offsetWidth + gap;
    }

    prev.addEventListener('click', () => {
      trackWrap.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      trackWrap.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });
}


document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-category-toggle]');
  const close = event.target.closest('[data-category-close]');
  const panel = document.querySelector('[data-category-panel]');

  if (!panel) return;

  if (toggle) {
    panel.classList.add('is-open');
    document.body.classList.add('is-shinkawa-category-open');
    return;
  }

  if (close) {
    panel.classList.remove('is-open');
    document.body.classList.remove('is-shinkawa-category-open');
    return;
  }
});


document.addEventListener('click', function(event) {
  const clearButton = event.target.closest('[data-shinkawa-clear-filters]');
  if (!clearButton) return;

  event.preventDefault();

  const drawer = clearButton.closest('facets-drawer');
  const form = drawer ? drawer.querySelector('form.facets') : document.querySelector('form.facets');

  if (form) {
    form.querySelectorAll('input[type="checkbox"]').forEach(input => {
      input.checked = false;
    });

    form.querySelectorAll('input[type="number"]').forEach(input => {
      input.value = '';
    });

    form.querySelectorAll('input[type="range"]').forEach(input => {
      if (input.min !== undefined) {
        input.value = input.defaultValue || input.min;
      }
    });
  }

  window.location.href = clearButton.dataset.clearUrl;
});

document.addEventListener('DOMContentLoaded', function () {
  const categoryPanel = document.querySelector('.shinkawa-sp-category-panel');

  if (categoryPanel && categoryPanel.parentElement !== document.body) {
    document.body.appendChild(categoryPanel);
  }
});

document.addEventListener('click', function (event) {
  const closeButton = event.target.closest('[data-sort-close]');
  if (!closeButton) return;

  const popover = document.getElementById('sort-by-popover');
  if (!popover) return;

  popover.removeAttribute('open');
  popover.setAttribute('aria-hidden', 'true');
});


document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.product-gallery');

  galleries.forEach((gallery) => {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    const prev = gallery.querySelector('.shinkawa-product-gallery-arrow--prev');
    const next = gallery.querySelector('.shinkawa-product-gallery-arrow--next');

    if (!carousel || !prev || !next) return;

    const updateArrows = () => {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const current = carousel.scrollLeft;

      prev.classList.toggle('is-disabled', current <= 2);
      next.classList.toggle('is-disabled', current >= maxScroll - 2);
    };

    carousel.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    setTimeout(updateArrows, 300);
  });
});


function initShinkawaProductCarousels() {
  document.querySelectorAll('.shinkawa-product-carousel').forEach((carousel) => {
    if (carousel.dataset.carouselInitialized === 'true') return;

    const trackWrap = carousel.querySelector('[data-shinkawa-carousel-track-wrap]');
    const track = carousel.querySelector('[data-shinkawa-carousel-track]');
    const nav = carousel.querySelector('[data-shinkawa-carousel-nav]');
    const prev = nav?.querySelector('button:first-child');
    const next = nav?.querySelector('button:last-child');

    if (!trackWrap || !track || !nav || !prev || !next) return;

    function getStep() {
      const item = track.querySelector('.shinkawa-product-carousel__item');
      if (!item) return 0;

      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item.offsetWidth + gap;
    }

    function updateButtons() {
      const maxScroll = Math.max(trackWrap.scrollWidth - trackWrap.clientWidth, 0);
      const current = trackWrap.scrollLeft;

      prev.disabled = current <= 1;
      next.disabled = current >= maxScroll - 1;
      nav.hidden = maxScroll <= 1;
    }

    prev.addEventListener('click', () => {
      trackWrap.scrollBy({
        left: -getStep(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', () => {
      trackWrap.scrollBy({
        left: getStep(),
        behavior: 'smooth'
      });
    });

    trackWrap.addEventListener('scroll', () => {
      requestAnimationFrame(updateButtons);
    });

    window.addEventListener('resize', updateButtons);

    setTimeout(updateButtons, 300);

    carousel.dataset.carouselInitialized = 'true';
  });
}